module.exports = __webpack_public_path__ + "img/pollbackground-placeholder.612a3b2f.jpg";